export const GOOGLE_CAPTCHA_KEY = '6Lcl5zkrAAAAAP-dxZZgulJL2lqL5Wkpe8gY1jFs'
